import axios from 'axios';
import {apiBaseUrl} from "../../../helpers/UrlHelper";
import {loginToken, logOut} from '../../../helpers/LocalStorageHelper'
import {handleError} from '../../../helpers/ErrorHelper'

function _success(success) {
    return {type: 'GET_LOGGEDIN_USER_SUCCESS', success};
}

function _error(error) {
    return {type: 'GET_LOGGEDIN_USER_ERROR', error};
}

function _processing(processing) {
    return {type: 'GET_LOGGEDIN_USER_PROCESSING', processing};
}

function getLoggedInUser() {
    return (dispatch) => {
        dispatch(_processing(true));
        // dispatch(_success(null));
        dispatch(_error(null));

        axios({
            url: apiBaseUrl(`admin/loggedin`),
            method: "get",
            dataType: 'json',
            headers: {'Authorization': 'Bearer ' + loginToken()}
        })
            .then(function (res) {
                dispatch(_success(res));
                dispatch(_processing(false));
            }).catch(function (error) {

            if (error && error.response &&
                error.response.status === 401) {
                logOut()
            } else {
                handleError(error)
                dispatch(_error(error));
                dispatch(_processing(false));
            }
        });
    }
}


export default getLoggedInUser;